import { useState } from "react";
import { LifeBuoy } from "lucide-react";

const btn = "rounded-full px-3 py-2 text-[13px] font-semibold disabled:opacity-50";

/** Student: "Je bloque" on one of the active activities. */
export const HelpAskCard = ({ api, plans, mobileType = false, onSent }) => {
  const [planId, setPlanId] = useState(plans[0]?.id || "");
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [sent, setSent] = useState(null);
  const text = mobileType ? "text-[15px]" : "text-[13px]";

  const send = async () => {
    setBusy(true);
    setError("");
    try {
      const request = await api.askHelp(planId, note.trim());
      setSent(request);
      onSent?.(request);
    } catch (problem) {
      setError(problem.message || "Envoi impossible.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="w-[94%] sm:w-[88%] max-w-[23rem] self-start rounded-2xl rounded-tl-sm bg-white p-2.5 sm:p-3 shadow-sm" data-testid="help-ask-card">
      <div className="flex items-center gap-2">
        <span className="flex h-8 w-8 items-center justify-center rounded-full bg-[#FFF4E5] text-[#b26a00]">
          <LifeBuoy className="h-4 w-4" />
        </span>
        <p className={`font-semibold text-[#122118] ${text}`}>Je bloque</p>
      </div>
      {sent ? (
        <p className={`mt-3 text-[#2d5a3d] ${text}`} data-testid="help-ask-done">✓ Demande envoyée · {sent.planTitle}</p>
      ) : (
        <>
          {plans.length > 1 && (
            <div className="mt-3 flex flex-wrap gap-1.5">
              {plans.map((plan) => (
                <button
                  key={plan.id}
                  type="button"
                  onClick={() => setPlanId(plan.id)}
                  className={`rounded-full border px-3 py-1.5 text-xs font-semibold ${planId === plan.id ? "border-[#25D366] bg-[#E9FBF0] text-[#128a3e]" : "border-gray-200 text-[#4a5f53]"}`}
                  data-testid={`help-ask-plan-${plan.id}`}
                >
                  {plan.title}
                </button>
              ))}
            </div>
          )}
          {plans.length === 1 && <p className={`mt-2 text-[#4a5f53] ${text}`}>{plans[0].title}</p>}
          <textarea
            value={note}
            onChange={(event) => setNote(event.target.value)}
            maxLength={500}
            rows={3}
            placeholder="Qu’est-ce qui bloque ? (facultatif)"
            className="mt-2 w-full rounded-xl border border-gray-200 px-3 py-2 text-[14px] outline-none focus:border-[#25D366]"
            data-testid="help-ask-note"
          />
          {error && <p className="mt-2 text-xs text-[#9b3b3b]" data-testid="help-ask-error">{error}</p>}
          <button type="button" onClick={send} disabled={busy || !planId} className={`${btn} mt-2 w-full bg-[#25D366] text-[#0a2914]`} data-testid="help-ask-submit">
            {busy ? "Envoi…" : "Prévenir mon parent"}
          </button>
        </>
      )}
    </div>
  );
};

export default HelpAskCard;
